import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import SearchSvg from 'resources/svg/icons/search.svg'

export const Wrapper = styled.div`
  min-width: 200px;
  margin-left: 15px;
  border: 1px solid ${props => props.theme.palette.general.grey};
  border-radius: 5px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;

  label {
    text-transform: uppercase;
    display: block;
    text-align: center;
    font: ${font('default', 'bold', '12px/1.5')};
    margin-bottom: 10px;
  }

  .form-field--input {
    position: relative;
    padding-bottom: 0;

    &::before {
      content: '';
      position: absolute;
      width: 30px;
      height: 100%;
      background: url(${SearchSvg}) no-repeat;
      background-size: 18px;
      background-position: 5px center;
      filter: invert(87%) sepia(0%) saturate(3545%) hue-rotate(339deg) brightness(96%) contrast(95%);
    }
  }

  input {
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    height: 30px;
    padding: 10px 5px 10px 30px;
    border-radius: 2px;
  }

  button {
    margin-top: 12px;
    text-transform: uppercase;
    font: ${font('default', 'bold', '16px/1')};
    background: ${props => props.theme.palette.primary.alpha};
    width: 100%;

    > div {
      padding: 8px 26px;
    }
  }
`
